import { DataCrafterTemplateColumn } from '.';

/**
 * Represents an output variant for a DataCrafter template.
 * This allows defining multiple output mappings based on user-defined preconditions.
 */
export default class DataCrafterOutputVariant {
    /** Unique identifier for the output variant */
    variantId?: string;

    /** Name of the output variant */
    name: string;

    /** Timestamp when the variant was created */
    createdTime: string;

    /** Timestamp when the variant was last updated */
    updatedTime?: string;

    /** User who created the variant */
    createdBy: string;

    /** User who last updated the variant */
    updatedBy?: string;

    /** Condition that determines when this variant should be used */
    condition: string;

    /** Array of template columns for this variant */
    columns: DataCrafterTemplateColumn[];

    /** Whether this is the default variant */
    isDefault: boolean;

    /** Generated code for this variant */
    code: string;

    /** Server-side reference for the latest generated code for this variant */
    scriptRefId?: string;

    /** ID of the parent DataCrafter template */
    dataCrafterTemplateId: string;

    constructor(
        name: string,
        createdTime: string,
        createdBy: string,
        condition: string,
        columns: DataCrafterTemplateColumn[],
        isDefault: boolean,
        code: string,
        dataCrafterTemplateId: string,
        variantId?: string,
        updatedTime?: string,
        updatedBy?: string,
        scriptRefId?: string
    ) {
        this.variantId = variantId;
        this.name = name;
        this.createdTime = createdTime;
        this.updatedTime = updatedTime;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
        this.condition = condition;
        this.columns = columns;
        this.isDefault = isDefault;
        this.code = code;
        this.scriptRefId = scriptRefId;
        this.dataCrafterTemplateId = dataCrafterTemplateId;
    }
}
